<div class="loader-container">
    <app-loader [remainingAmount]="remainingAmount" [color]="color" [showNumber]="true" [number]="remainingTimeInSeconds"></app-loader>
</div>
